// extracted by mini-css-extract-plugin
export default {"backdrop":"PopUp_backdrop__LHDTj","modal":"PopUp_modal__BsfZX"};